import React, { Component } from 'react'
import { Button, Card, Form, Input, Modal, PageHeader, Typography, message } from 'antd'
import { adopterUserDelete } from 'services/api'
import { ExclamationCircleOutlined } from '@ant-design/icons'

export default class AdoptionDeleteAdopter extends Component {

  confirmDelete = async (val) => {
    let response = await adopterUserDelete(val,"true")
    if(response?.data?.status === 200){
      message.success(`adopter deleted successfully!`);
    }else{
      message.error(response?.data.message);
    }
  }

  render() {
          return (
            <Card>
              <PageHeader title="Delete Adopter’s Account" >
                <Typography.Text>This will permanently remove the adopter’s account.</Typography.Text>
                <br/><br/>
              <Form
                name="basic"
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                onFinish={async (val) => {
                  let response = await adopterUserDelete(val,"false")
                  if(response?.data?.status === 3703){
                    Modal.confirm({
                      title: `Delete Adopter’s Account`,
                      content: `Are you sure about removing ${response.data?.data?.full_name} - ${response.data?.data?.email} account?`,
                      icon: <ExclamationCircleOutlined />,
                      cancelText: 'No',
                      okText: 'Yes',
                      onOk: () => {
                        this.confirmDelete(val)
                      }
                    })
                    
                  }else{
                    message.error(`Adopter User Not Found!`);
                  }
                  
                }}
                autoComplete="off"
              >
                <Form.Item
                  label="Adopter email"
                  name="email"
                  rules={[{ required: true, message: 'Please input your adopter email!' }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
              </PageHeader>
              
            </Card>
          )
          }
        }